import { InfoIcon } from '@assets/icons/info';
import { TaInput } from '@components/shared';
import CustomTooltip from '@components/tooltip/tooltip';
import { Box, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

// PYO8UH

interface SpecialistCodeInputProps {
	formik: FormikProps<any>;
	handleChange: (e: any) => void;
}

export const SpecialistCodeInput = ({ formik, handleChange }: SpecialistCodeInputProps) => {
	const { t } = useTranslation();
	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		console.log('Specialist code input changed:', e.target.value);
		formik.handleChange(e); // Update formik value
		handleChange(e.target.value); // Call the debounced handler with value
	};

	return (
		<div className="relative">
			<TaInput
				rightPadding="30px"
				id="code"
				value={formik.values.code}
				onChange={handleInputChange}
				label={t('findSpecialistPage.specialistsCode')}
				size="small"
			/>
			<CustomTooltip
				placement="top"
				title={
					<Box className="flex items-center gap-[10px] text-blue">
						<Typography>{t('findSpecialistPage.specialistCodeTooltip')}</Typography>
					</Box>
				}
			>
				<div className="absolute right-3 top-1/2 -translate-y-1/2">
					<InfoIcon className="w-[24px] h-[24px]" />
				</div>
			</CustomTooltip>
		</div>
	);
};
